import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import isEqual from 'react-fast-compare';
import messages from '../../../../res/translations/messages';
import ConvertItemButton from './ConvertItemButton';
import CloneItemButton from './CloneItemButton';
import DeleteItemButton from './DeleteItemButton';
import editorConverters from '../../../services/editorConverters';
import TypeIcon from './TypeIcon';
import TerminalIndicator from './TerminalIndicator';
import PreScriptsIndicator from './PreScriptIndicator';
import PostScriptsIndicator from './PostScriptsIndicator';
import OptionsScriptsIndicator from './OptionsScriptsIndicator';
import RowsScriptsIndicator from './RowsScriptsIndicator';
import HiddenPageIndicator from './HiddenPageIndicator';
import Icon from '../../Icon';
import TooltipContainer from '../../TooltipContainer';
import {stripHtml} from '../../../utils/text';
import {constants} from '@neosvoc/nv-platform-core-common';

class PageHeader extends React.Component {
    constructor(props) {
        super(props);

        this.handleConvert = this.handleConvert.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleMoveUp = this.handleMoveUp.bind(this);
        this.handleMoveDown = this.handleMoveDown.bind(this);
        this.handleClone = this.handleClone.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
    }

    handleRemove() {
        this.props.remove(this.props.index);
    }

    handleMoveUp() {
        this.props.move(this.props.index, this.props.index - 1);
    }

    handleMoveDown() {
        this.props.move(this.props.index, this.props.index + 1);
    }

    handleConvert(type) {
        const convertedItem = editorConverters[this.props.item.items[0].type][type](this.props.item.items[0], type);
        const newPageItem = Object.assign({}, this.props.item, {
            items: [convertedItem],
        });
        this.props.replace(this.props.index, newPageItem);
    }

    handleClone() {
        this.props.onClonePage(this.props.item, this.props.index + 1);
    }

    render() {
        const {item, index, len} = this.props;
        let type = item.items[0] && item.items[0].type;
        const hiddenPage = type === constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2;
        // Verifico se sia una variabile di rating controllando il componentType
        const isRating = item.items[0] && item.items[0].componentType === 'rating';
        if (isRating) {
            // Verifico se sia una batteria o una variabile secca
            type = (type === constants.EDITOR_TEMPLATES.NUMBER_2) ? constants.EDITOR_TEMPLATES.NUMBER_3 : constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_4;
        }
        return (
            <>
                <div className="question-type border-left text-center align-items-center">
                    <TypeIcon type={type} height="32px" width="32px" />
                </div>
                <div className="question-id border-left">
                    {item.items[0].id}
                </div>
                <div className="page-id border-left">
                    {item.id}<br />
                    <PreScriptsIndicator preScripts={item.preScripts} />
                    <OptionsScriptsIndicator optionsScripts={item.optionsScripts} />
                    <RowsScriptsIndicator rowsScripts={item.rowsScripts} />
                    <PostScriptsIndicator postScripts={item.postScripts} />
                    <TerminalIndicator terminal={item.terminal} />
                    <HiddenPageIndicator hiddenPage={hiddenPage} />
                </div>
                <div className="page-header border-left d-flex flex-column justify-content-center">
                    {item.items[0] && stripHtml(item.items[0].title || item.items[0].text) || (
                        <div className="missing"><FormattedMessage {...messages.surveys.form.label.missingText} /></div>
                    )}
                    <div className="question-type-name"><FormattedMessage {...messages.types[type]} /></div>
                </div>
                <ConvertItemButton item={item.items[0]} onConvert={this.handleConvert} />
                <CloneItemButton item={item} onClone={this.handleClone} />
                <div className="page-move-buttons">
                    <TooltipContainer component="button" tooltip={messages.surveys.tooltips.moveUp} className="btn btn-link"
                        onClick={this.handleMoveUp} type="button" disabled={!(index > 0)}>
                        <Icon icon="arrow_full_up" />
                    </TooltipContainer>
                    <TooltipContainer component="button" tooltip={messages.surveys.tooltips.moveDown} className="btn btn-link"
                        onClick={this.handleMoveDown} type="button" disabled={!(index + 1 < len)}>
                        <Icon icon="arrow_full_down" />
                    </TooltipContainer>
                </div>
                <DeleteItemButton itemId={item.id} type="danger" onClick={this.handleRemove} />
            </>
        );
    }
}

PageHeader.propTypes = {
    index: PropTypes.number.isRequired,
    len: PropTypes.number.isRequired,
    item: PropTypes.shape({
        id: PropTypes.string,
        items: PropTypes.array,
        preScripts: PropTypes.array,
        postScripts: PropTypes.array,
        optionsScripts: PropTypes.array,
        rowsScripts: PropTypes.array,
        terminal: PropTypes.bool,
    }).isRequired,
    move: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    onClonePage: PropTypes.func.isRequired,
};

export default PageHeader;
